export default function Verification() {
  return (
    <div style={{ padding: 24 }}>
      <h2>认证管理</h2>
      <p style={{ color: '#999' }}>功能开发中...</p>
    </div>
  )
}
